"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _store = require("../../../redux/store");
var _deliveryDetailsSlice = require("../../../redux/deliveryDetailsSlice");
var _giftSlice = require("../../../redux/giftSlice");
var _popupSlice = require("../../../redux/popupSlice");
var _MyAccountInput = _interopRequireDefault(require("../../MyAccountInput"));
var _SkeletonWrapper = _interopRequireDefault(require("../../SkeletonWrapper"));
var _helpers = require("./helpers");
var _RecipientFormStyled = require("./RecipientFormStyled");
var _validators = require("./validators");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RecipientForm = _ref => {
  let {
    isMyAccount = false
  } = _ref;
  const {
    recipientEmail,
    confirmRecipientEmail,
    deliveryDate,
    deliveryTime,
    message
  } = (0, _store.useAppSelector)(_deliveryDetailsSlice.selectDeliveryDetails);
  const {
    loading,
    gift: {
      deliveryDetails: giftDeliveryDetails,
      redeemedAt,
      sentAt
    }
  } = (0, _store.useAppSelector)(_giftSlice.selectGift);
  const {
    isOpen,
    currentType
  } = (0, _store.useAppSelector)(_popupSlice.selectPopupDetails);
  const dispatch = (0, _store.useAppDispatch)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const onBlur = e => {
    const {
      target: {
        name,
        value
      }
    } = e;
    switch (name) {
      case 'recipientEmail':
        (0, _validators.validateRecipientEmail)(value);
        if (confirmRecipientEmail.value) {
          (0, _validators.validateConfirmRecipientEmail)(confirmRecipientEmail.value);
        }
        break;
      case 'confirmRecipientEmail':
        (0, _validators.validateConfirmRecipientEmail)(value);
        break;
      case 'deliveryDate':
        (0, _validators.validateDeliveryDate)(value, deliveryTime.value);
        break;
      case 'deliveryTime':
        (0, _validators.validateDeliveryTime)(value, deliveryDate.value);
        break;
      default:
        break;
    }
  };
  const onChange = e => {
    if (shouldHideValue) {
      return;
    }
    const {
      target: {
        name,
        value
      }
    } = e;
    dispatch((0, _deliveryDetailsSlice.setFieldValue)({
      name,
      value
    }));
    if (name === 'deliveryDate' && !deliveryTime.value) {
      dispatch((0, _deliveryDetailsSlice.setFieldValue)({
        name: 'deliveryTime',
        value: '00:00'
      }));
    }
  };
  (0, _react.useEffect)(() => {
    if (isMyAccount && giftDeliveryDetails) {
      dispatch((0, _deliveryDetailsSlice.setFieldValue)({
        name: 'recipientEmail',
        value: giftDeliveryDetails === null || giftDeliveryDetails === void 0 ? void 0 : giftDeliveryDetails.recipientEmail
      }));
      dispatch((0, _deliveryDetailsSlice.setFieldValue)({
        name: 'deliveryDate',
        value: (0, _helpers.getDate)(giftDeliveryDetails === null || giftDeliveryDetails === void 0 ? void 0 : giftDeliveryDetails.deliveryDate)
      }));
      dispatch((0, _deliveryDetailsSlice.setFieldValue)({
        name: 'deliveryTime',
        value: (0, _helpers.getTime)(giftDeliveryDetails === null || giftDeliveryDetails === void 0 ? void 0 : giftDeliveryDetails.deliveryDate)
      }));
      dispatch((0, _deliveryDetailsSlice.setFieldValue)({
        name: 'message',
        value: giftDeliveryDetails === null || giftDeliveryDetails === void 0 ? void 0 : giftDeliveryDetails.personalNote
      }));
    }
  }, [giftDeliveryDetails]);
  const isGiftEditable = (0, _validators.isDateInFuture)(new Date((giftDeliveryDetails === null || giftDeliveryDetails === void 0 ? void 0 : giftDeliveryDetails.deliveryDate) * 1000)) && !sentAt && !redeemedAt;
  const isFieldDisabled = isMyAccount && !isGiftEditable;
  const isEditDeliveryDetailsPopupOpened = isOpen && currentType === _popupSlice.POPUP_TYPES.EDIT_DELIVERY_DETAILS_POPUP;
  const shouldHideValue = !isMyAccount && isEditDeliveryDetailsPopupOpened;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RecipientFormStyled.StyledRecipientForm, {
    noValidate: true,
    children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          width: 100,
          margin: "0 0 12px 0"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          height: 40,
          margin: "0 0 28px 0"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          width: 100,
          margin: "0 0 12px 0"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          height: 40,
          margin: "0 0 28px 0"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          width: 100,
          margin: "0 0 12px 0"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
          height: 92,
          margin: "0 0 28px 0"
        })]
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
        disabled: isFieldDisabled,
        error: t(recipientEmail.translationKey, recipientEmail.error),
        label: t('recipientForm.label.recipient-email', 'Recipient email'),
        name: "recipientEmail",
        onBlur: onBlur,
        onChange: onChange,
        placeholder: t('recipientForm.label.recipient-email', 'jdoe@cleeng.com'),
        type: "email",
        value: shouldHideValue ? '' : recipientEmail.value
      }), !isFieldDisabled && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
        error: t(confirmRecipientEmail.translationKey, confirmRecipientEmail.error),
        label: t('recipientForm.label.confirm-recipient-email', 'Confirm recipient email'),
        name: "confirmRecipientEmail",
        onBlur: onBlur,
        onChange: onChange,
        placeholder: t('recipientForm.label.confirm-recipient-email', 'jdoe@cleeng.com'),
        type: "email",
        value: shouldHideValue ? '' : confirmRecipientEmail.value
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RecipientFormStyled.DateContainer, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
          disabled: isFieldDisabled,
          error: t(deliveryDate.translationKey, deliveryDate.error),
          label: t('recipientForm.label.delivery-date', 'Delivery date'),
          min: new Date().toISOString().split('T')[0],
          name: "deliveryDate",
          onBlur: onBlur,
          onChange: onChange,
          type: "date",
          value: shouldHideValue ? '' : deliveryDate.value,
          width: "50%"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyAccountInput.default, {
          disabled: isFieldDisabled,
          error: t(deliveryTime.translationKey, deliveryTime.error),
          label: t('recipientForm.label.delivery-time', 'Delivery time'),
          name: "deliveryTime",
          onBlur: onBlur,
          onChange: onChange,
          type: "time",
          value: shouldHideValue ? '' : deliveryTime.value,
          width: "50%"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_RecipientFormStyled.MessageWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_RecipientFormStyled.StyledLabel, {
          children: isFieldDisabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
            children: t('recipientForm.label.message', 'Message')
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
            children: t('recipientForm.label.add-message', 'Add a message')
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RecipientFormStyled.StyledMessage, {
          disabled: isFieldDisabled,
          maxLength: 150,
          name: "message",
          onChange: onChange,
          placeholder: isFieldDisabled ? '' : t('recipientForm.placeholder.message', 'I’d give you the gift of never having to leave the house again! Enjoy your new subscription plan. Happy streaming!'),
          rows: 3,
          value: shouldHideValue ? '' : message.value
        })]
      }), !isMyAccount && /*#__PURE__*/(0, _jsxRuntime.jsx)(_RecipientFormStyled.InfoText, {
        children: t('recipientForm.info-text', 'To edit your gift delivery details, access MyAccount and click on the corresponding transaction.')
      })]
    })
  });
};
var _default = exports.default = RecipientForm;